export default {
  share: {
    title: '連接·生活',
    openButton: '打開MyLink查看更多',
    download: '下載 MyLink APP',
    open: '打開',
    wxGuide: {
      ios: '請點擊右上角的“…”按鈕，選擇“在Safari中開啟”',
      android: '請點擊右上角的“…”按鈕，選擇“在瀏覽器中開啟”'
    }
  },
  netEttor: {
    cancel: '取消',
    oterError: '其它錯誤類',
    checkNetwork: '請檢查是否已連接到網絡',
    backHome: '返回首頁'
  },
  policy: [
    '私隱政策聲明',
    '總覽',
    '本聲明是由中國移動香港有限公司（「我們」或「中移香港」）根據香港特別行政區法例第486章《個人資料（私隱）條例》（「條例」）而作出。',
    '本聲明說明我們在收集、使用、轉移、和查閱顧客個人資料的政策和做法。本聲明內「個人資料」一詞含有條例所解釋的意義。',
    '為何我們收集閣下資料？ ',
    '我們不時向閣下收集個人資料，以便向閣下提供我們的產品或服務。所收集資料包括但不限於：',
    ['閣下的姓名；',
      '安裝服務的地址、通訊地址及/或寄發賬單的地址；',
      '賬戶詳情、包括賬戶號碼、服務號碼或使用者帳號；',
      '身份證號碼或護照號碼或港澳居民來往內地通行證號碼；',
      '付款詳情，包括信用卡及銀行資料；及',
      '聯絡詳情，包括聯絡人姓名、電話號碼、傳真號碼或電郵地址。'
    ],
    '閣下沒有義務向我們提供閣下的個人資料，但如閣下不提供個人資料，我們可能無法向閣下提供所需的產品和服務。',
    '為了讓閣下有更佳的客戶體驗，我們可能邀請閣下自願提供年齡、出生日期、性別、教育程度及職業、薪金水平、興趣愛好及公餘活動，其他有關並已申請的產品及服務，家庭及家居統計等資料。我們會在有關表格或申請表上指出所需的個人資料是否必須提供。',
    '此外，閣下的線上資料可能會以總計及不記名方式被間接收集。',
    '倘若閣下年齡未滿13歲，閣下必須徵得閣下家長或監護人的同意，方可向我們提供任何個人資料。',
    '閣下資料的可能用途',
    '閣下的個人資料可能被使用於以下各項之目的：',
    ['核實閣下身份；',
      '處理閣下選購我們的產品和服務的申請；',
      '向閣下提供產品和服務；',
      '規管及執行閣下所選購的長期客戶優惠計劃；',
      '管理向閣下提供的產品和服務包括續約事宜；',
      '通知閣下有關我們提供的產品和服務的最新資訊；',
      '根據本聲明第10段列明的，在取得閣下的同意下作推廣和宣傳之用；',
      '與就其他目的而從其他來源包括第三方所收集的資料作核對，以提升閣下的客戶體驗；',
      '內部統計及分析用途；',
      '根據閣下的需要，為閣下設計及改善產品和服務；',
      '處理閣下的查詢、投訴和回饋；',
      '日常業務監察及管理；',
      '透過電郵、電話、信函或其他途徑聯絡閣下；',
      '記賬；',
      '處理付款提示；',
      '收取閣下賬戶未付的款項(包括聘用追收債務代理人和民事訴訟)及信貸調查；',
      '尋求法律諮詢和在法律程序中提出法律索賠或辯護；',
      '預防和調查欺詐及其他犯罪活動；',
      '根據任何地區的法例、規則、法庭命令而作出或可作出的披露或任何政府、監管機關或執法機構要求的披露；',
      '與上述任何用途有關及相關或其他閣下不時同意的用途之任何其他用途。'
    ],
    '個人資料的披露和轉移 ',
    '我們可能會向以下各方轉移、披露或共用享閣下的個人資料（不論是在香港境內或境外）以達到上述第7段的目的，閣下的個人資料可能被轉移至香港境內或境外。',
    ['任何附屬公司、控股公司、關聯公司，或由我們所持有或與我們同屬一家控制公司的公司或聯營公司；',
      '任何代表我們或與我們聯營的個人或公司，以達到提供此等資料之目的，或直接與其有關之目的；',
      '有責任為我們對上述資料保密的任何其他人士或公司，而該人士或公司有法定的權利取用該資料；',
      '我們的經銷商、代理、承辦商、供應商、及其他電訊、資訊服務商及内容供應商；我們的專業顧問，包括會計師、審計師及律師；',
      '政府和監管機關、執法機構和法律規定或授權的其他組織；',
      '任何所需的金融機構、收費或信用卡發行公司、信貸提供者、信貸資料或調查機構，或代收欠款的代理人、證劵代理，以便設立和支援任何所需求服務的支付；',
      '閣下的授權代表或法律顧問（在閣下要求下）；',
      '電訊網絡運營商；',
      '第三方獎賞和長期客戶優惠計劃供應商；',
      '管理我們業務及企業策略的組織，包括為該等目的參與轉讓/出售我們全部或部份的資產或業務（包括帳戶和應收賬款）以及參 與管理我們的企業風險和資金籌集功能（例如證券化）的組織；以及',
      '有關我們全部或部份運營業務的任何潛在或實際參與者、承讓人或受讓方。'
    ],
    '個人資料的保安和保存',
    '我們一貫致力確保閣下的個人資料受安全保護，不會未經授權或意外地被他人取得、處理、清除或作其他用途。為致力保障閣下個人資料安全，我們在設施、電子系統及管理方面實施適當措施，以保障閣下的個人資料安全。除非個人資料基於合約或適用法例而另作保存，否則我們只會在就原來收集目的(或其直接相關目的)而言必須的期間內保存個人資料。',
    '個人資料用於直接促銷用途',
    '根據條例及在閣下同意的情況下，我們會將包括但不限於本聲明第3至5段提及的個人資料作直接促銷的用途，包括發送任何與我們或我們的商業夥伴的產品和服務有關的資訊、長期客戶優惠計劃、活動（包括與第三方合作的活動）、最新情報、比賽、抽獎等。上述資訊可能包括不同的推廣資料，包括但不限於流動裝置及配件、電訊網絡服務如電視、流動話音、短訊及數碼通訊、IDD/國際漫遊、互聯網連接、流動應用程式、娛樂及互聯網數據通訊、其他增值服務、以及電腦周邊產品、配件和軟件(包括筆記型電腦、手提電話、鍵盤、保安裝置及流動應用程式)、秘書服務、個人助理服務和資訊服務、遊戲、運動、音樂、美容產品、電子產品、科技、電子商務、手機付款、旅遊、銀行、投資、娛樂、交通、家居、時尚、餐飲、煙酒、保險、教育、健康及保健、社交網絡、慈善活動、媒體及高端消費類產品及服務。我們可能透過信函、電話、電郵、傳真或其他途徑傳送上述資訊給閣下。',
    '除非閣下表示同意或不反對，否則我們不能使用閣下的個人資料作直接促銷的目的。倘若閣下希望停止接收我們直接促銷的資訊，閣下可隨時依本聲明第14條列明的方法致函我們。所有此等要求，應明確列出有關的個人資料和聯絡詳情以確認身份。',
    'Cookies的使用和位置資料',
    '若閣下使用我們的任何網站，我們可能使用cookie文件儲存及跟蹤與閣下及閣下的偏好有關的資料。Cookie是由我們的網站傳輸至閣下設備上的小型文本文件。透過Cookies的使用，我們能夠更好地服務閣下，及/或在一個或多個瀏覽時段中跨越多個頁面地保持閣下的資料。大多數網絡瀏覽器均自動接受Cookies，但是若閣下選擇，閣下可更改閣下的瀏覽器選項以禁用Cookies。Cookies儲存與閣下及閣下的偏好有關的資料。例如，若閣下查詢價格及供應情況，網站可能會建立含有閣下所輸入的資料的Cookie。 Cookie亦可以只儲存閣下在網站中所瀏覽的網頁記錄，以幫助網站為閣下定制閣下於下一次瀏覽時的畫面。只有閣下在使用網站時提供的資料或所作出的選擇能夠存儲於cookie中。例如，除非閣下選擇輸入電郵地址，否則網站無法確定閣下的電郵地址。允許網站建立Cookie並不會令該網站或任何其他網站能夠存取閣下的設備的其餘部分，而且只有建立Cookie的網站能夠閱讀該Cookie。',
    '我們可將閣下的位置資料用於跟蹤閣下的活動模式及偏好，以改進閣下獲得的服務水平。閣下的位置資料可能與我們從第三方接收的其他資料合併， 以便向閣下提供更佳的服務。在閣下同意接受直接促銷的情況下，我們可就上述第10條的直接促銷類別向閣下提供針對性的廣告、內容、交易及優惠。',
    '查閱或更正個人資料',
    '閣下有查閱其個人資料的權利。若閣下欲取得該等資料的副本或認為我們收集及保留了不準確的個人資料，請致函下列地址： ',
    '資料保護主任中國移動香港有限公司香港新界葵涌葵昌路51號九龍貿易中心1座20樓',
    '有關查閱或更正個人資料的要求或對我們在收集顧客個人資料的政策和做法的查詢，可致函我們上述地址。根據私隱條例規定，我們有權為受理資料查核要求而收取合理費用。',
    '其他',
    '我們保留不時修改本聲明的權利。',
    '本聲明的中文版和英文版如有抵觸，概以英文版為準。',
    '版本: E201609a'
  ]
}



// WEBPACK FOOTER //
// ./src/locale/global/zh-hk.js